import Components from '../../Components';
import { getWebsiteUrl } from '../../Core/Utils/linkGenerator';
import { ROOM_BOOKING_PATH } from './constants';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: ROOM_BOOKING_PATH,
  exact: true,
  name: 'navigation.menu.meetingroom',
  private: true,
  type: containerTypes.SUBCONTENT,
  grouping: 'navigation.grouping.reserve',
  shortPathName: 'navigation.menu.meetingroomshort',
  requiresMemberPortalAccess: true,
  isHardRedirect: true,
  externalUrl: () => getWebsiteUrl('meeting-rooms'),
};

export default RouteConfig;
